var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",attrs:{"width":_vm.wave.length,"height":"100"},on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }